
/**
 *  <Desription of Service here>
 *
 * @export
 * @class FullscreenManager
 */
export class FullscreenManager {

  /**
   * $inject to make angular DI minification safe
   *
   * @static
   * @type {Array<string>}
   */
  public static $inject: [string] = ['$log']
  public screenfull: any
  public isFullScreen: boolean
  public canGoFullScreen: boolean
  public fullScreenElement: any

  /**
   * @param {$log} $log - Angular logging Service.
   */
  constructor(public $log: any) {
    this.$log = $log.getInstance('FullscreenManager', false);
    this.$log.debug('constructor');

    this.screenfull = require('screenfull')
    this.isFullScreen = false
    this.canGoFullScreen = this.screenfull.enabled
    this.fullScreenElement = document.querySelector('app')
  }

  public goFullScreen(pageFullScreen: boolean = false) {
    this.$log.debug('goFullScreen()')
    if (this.screenfull.enabled) {
      if (pageFullScreen) {
        this.screenfull.request()
      } else {
        this.screenfull.request(this.fullScreenElement)
      }
      this.isFullScreen = true;
    }
  }

  public exitFullScreen() {
    this.$log.debug('exitFullScreen()')
    if (this.screenfull.enabled) {
      this.screenfull.exit();
      this.isFullScreen = false;
    }
  }

  public toggleFullScreen() {
    this.$log.debug('toggleFullScreen()')
    if (this.screenfull.enabled) {
      this.screenfull.toggle();
      if (this.screenfull.isFullScreen()) {
        this.isFullScreen = true;
      } else {
        this.isFullScreen = false;
      }
    }
  }

  public getFullScreenElement(): any {
    this.$log.debug('getFullScreenElement()')
    return this.screenfull.element();
  }

};



/** WEBPACK FOOTER **
 ** ./src/common/services/fullscreen-manager/fullscreen-manager.ts
 **/